<template>
  <base-view
      @click:add="criar"
      :permiteCadastrar="permiteCadastrar"
      @update:search-values="updateSearch"
      :search-columns="searchColumns">

    <CreateEditDemandaDialog :item="item" v-model="editDialogOpened"
                                  @onSave="() => $refs.dataTable.refresh()"/>
    <DetalheDemandaDialog :item="item" v-model="detalheDialogOpened"/>

    <div>
      <DemandaDataTable ref="dataTable"
                             @click:edit="editar"
                             @click:verDetalhe="verDetalhe"
                             @click:remove="remover"
                         :search-values="searchValues"/>
    </div>
    <v-overlay :value="loading" absolute>
      <v-progress-circular
        indeterminate
        color="primary"
        class="ma-4"
      ></v-progress-circular>
    </v-overlay>    
  </base-view>

</template>

<script>
import DemandaDataTable from "../../components/shared/datatables/DemandaDataTable";
import BaseView from "../BaseView";
import {findOne,remove} from "../../api/demanda";
import CreateEditDemandaDialog from "../../components/shared/dialogs/CreateEditDemandaDialog";
import DetalheDemandaDialog from "../../components/shared/dialogs/DetalheDemandaDialog";
import {ApiError} from "../../api/core";
import {mapActions, mapGetters} from "vuex";
import {findAll as findAllComprador} from '../../api/comprador';
import {findAll as findAllOferta} from '../../api/oferta';
import {ItemDeDominio} from "../../api/itemsDominio";
import * as moment from 'moment';

export default {
  name: "index",
  components: {CreateEditDemandaDialog, DetalheDemandaDialog, BaseView, DemandaDataTable},
  data() {
    return {
      item: null,
      loading: false,
      editDialogOpened: false,
      detalheDialogOpened: false,
      permiteCadastrar: false,
      selectedItems: [],
      searchValues: {},
      searchColumns: [
        {
          name: 'ID',
          column: 'id',
          type: 'number',
          prefix: '#'
        },
        {
          name: 'Comprador',
          column: 'idComprador',
          type: 'autocomplete',
          optionsFactory: (search) => findAllComprador(1, {
            nome: search,
          })
              .then(r => {
                return r.elements.map(e => ({
                  key: e.id,
                  valor: e.nomeCompleto
                }))
              })

        },
        {
          name: 'Ofertas',
          column: 'idOferta',
          type: 'autocomplete',
          optionsFactory: (search) => findAllOferta(1, {
            descricao: search
          })
              .then(r => {
                return r.elements.map(e => ({
                  key: e.id,
                  valor: e.descricao
                }))
              })
        }, 
        {
          name: 'Atendimento',
          column: 'estadoAtend',
          type: 'select',
          optionsFactory: () => this.fetch({
            itemDominio: ItemDeDominio.COMBO_ESTADO
          })
        },   
        {
          name: 'Descrição',
          column: 'descricao',
          type: 'text'
        },
        {
          group: 'Data Expiração',
          columns: [
            {
              name: 'De',
              column: 'dtInicio',
              type: 'date',
              defaultValue: moment().startOf('month').format('YYYY-MM-DD'),
            },
            {
              name: 'Até',
              column: 'dtFim',
              type: 'date',
            },
          ]
        },        
        {
          name: 'Status',
          column: 'status',
          type: 'select',
          optionsFactory: () => this.fetch({
            itemDominio: ItemDeDominio.STATUS_PADRAO
          })
        },
      ]
    }
  },
  computed: {
    ...mapGetters('auth',['user','isAuthenticated','nivelUsuarioLogado']),
  },  
  methods: {
    ...mapActions('itemsDominio', ['fetch']),
    updateSearch(search) {
      this.searchValues = search;
    },
    criar() {
      this.item = {
        id: null,
        idTipoItemOferta: "",
        descricaoTipoItemOferta: "",
        idOferta: null,
        descricaoOferta: "",
        idComprador: null,
        descricaoComprador: "",
        descricao: "",
        dataCadastro: "",
        dataExpiracao: "",
        status: "A",
        descricaoStatus: "",
        estados: []
      };
      this.editDialogOpened = true;
    },
    async getDemanda(id){
      try {
        const retorno = await findOne(id);
        return retorno.dados[0];
      } catch (err) {
        throw err;
      }
    },
    async editar(objeto) {
      try {
        this.loading = true;
        const demanda = await this.getDemanda(objeto.id);
        this.item = demanda;
        this.editDialogOpened = true;
      } catch (err) {
        if (err instanceof ApiError) {
          this.$toast.error(err.message, {
            timeout: 6000
          });
        } else {           
          this.$toast.error(`Não foi possível recuperar os dados da Demanda. Tente Novamente mais tarde.`, {
            timeout: 6000
          });
        }
      } finally {
        this.loading = false;
      }
    },
    async verDetalhe(objeto) {
      try {
        this.loading = true;
        const demanda = await this.getDemanda(objeto.id);
        this.item = demanda;
        this.detalheDialogOpened = true;
      } catch (err) {
        if (err instanceof ApiError) {
          this.$toast.error(err.message, {
            timeout: 6000
          });
        } else {           
          this.$toast.error(`Não foi possível recuperar os dados da Demanda. Tente Novamente mais tarde.`, {
            timeout: 6000
          });
        }
      } finally {
        this.loading = false;
      }
    }, 
    async remover({id}) {
      try {
        this.loading = true;
        await remove(id);
        this.$toast.success(`Demanda removida com sucesso.`, {
          timeout: 3000
        });
        this.$refs.dataTable.refresh();
      } catch (err) {
        if (err instanceof ApiError) {
          this.$toast.error(err.message, {
            timeout: 6000
          })
        } else {        
          this.$toast.error(`Não foi possível remover a Demanda.`, {
            timeout: 6000
          })
        }  
      } finally {
        this.loading = false;
      }
    },
	  async getPermissoes(){
      this.getPermissaoPorItemPerfil("Demanda.cadastro",this.nivelUsuarioLogado)
        .then(permissao => {
          this.permiteCadastrar = permissao;
        });      
    },
  },
  mounted() {
    this.getPermissoes();
  }
}
</script>

<style scoped lang="scss">

::v-deep {
  .v-data-table__wrapper {
    height: calc(100vh - 157px);
  }
}

</style>